import { Typography } from '@mui/material';

import { useTranslation } from '@mopla/i18';
import { ErrorAnim, MplButton, MplModal } from '@mopla/ui';

interface IMyTicketCancellationErrorModalProps {
	open: boolean;
	onClose: () => void;
}

export const MyTicketCancellationErrorModal = ({
	open,
	onClose,
}: IMyTicketCancellationErrorModalProps) => {
	const { t } = useTranslation('ticketshop');

	return (
		<MplModal
			open={open}
			testId="myTicketDetail-cancellationErrorModal"
			icon={<ErrorAnim />}
			title={t('my_ticket_detail.cancellation_error_modal.title')}
			content={
				<Typography variant="b2">
					{t('my_ticket_detail.cancellation_error_modal.description')}
				</Typography>
			}
			buttons={
				<MplButton
					testId="myTicketDetail-cancellationErrorModal-button"
					variant="contained"
					fullWidth
					onClick={onClose}
				>
					{t('my_ticket_detail.cancellation_error_modal.button')}
				</MplButton>
			}
		/>
	);
};
